import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62ca54e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=62ca54e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca54e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62ca54e4')) {
      api.createRecord('62ca54e4', component.options)
    } else {
      api.reload('62ca54e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62ca54e4&scoped=true", function () {
      api.rerender('62ca54e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layoutThree/index.vue"
export default component.exports